import { SubscribedPlan } from '../typings';
import { getSubscribedPlan } from '../requests/get-subscribed-plan';

export const getSubscribedPlanUseCase = async (): Promise<SubscribedPlan> => {
  const { subscribedPlan } = await getSubscribedPlan();

  return subscribedPlan;
};
